import { render } from "./Hotspot14.vue?vue&type=template&id=332c2d2c&scoped=true&ts=true"
import script from "./Hotspot14.vue?vue&type=script&lang=ts"
export * from "./Hotspot14.vue?vue&type=script&lang=ts"

import "./Hotspot14.vue?vue&type=style&index=0&id=332c2d2c&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332c2d2c"]])

export default __exports__